export default "__VITE_ASSET__CY$9JtVT__"